export class OAuthToken {

    static EXPIRATION = 'exp';

    access_token: string;
    refresh_token: string;
    token_type: string;
    expires_in: number;

    /**
     * extracts the expiration in milliseconds from the accessToken
     *
     * @returns {number}
     * @memberof OAuthToken
     */
    public getExpirationMilliseconds(): number {
        const parts = this.access_token.split('.');
        const body = JSON.parse(atob(parts[1]));
        const expiration = body[OAuthToken.EXPIRATION];

        if (expiration !== null && expiration !== '') {
            const num = Number(expiration);
            if (num !== Number.NaN) {
                return num;
            }
        }
        return null;
    }
}
